export default "__VITE_ASSET__DgGIKKoa__"